(function () {
  'use strict';
  angular.module('vcconsult')
    .component('consultnew', {
      restrict: 'E',
      bindings: {
        patientid: '<',
        oncreate: '&'
      },
      template: `
      <div class="consultnew-component" data-hook="consultnew-component">
        <div class="btn btn-success spacer-bottom" ng-click="vm.saveNewConsult()" ng-hide="vm.newconsult">Neue Konsultation starten</div>
        
        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> Konsultation erfolgreich angelegt!</h3>
        </div>
       
        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> Es konnte keine Konsultation angelegt werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Consult', 'Patient', 'Rlog',
        function ($log, Consult, Patient, Rlog) {
          let vm = this;
          vm.saveNewConsult = saveNewConsult;

          function saveNewConsult() {
            Patient.$find(vm.patientid).$then(function (pat) {
              let newrecord = {
                patientid: vm.patientid,
                clientid: vm.patientid,
                dicomconsultid: moment().valueOf().toString() + Math.floor(Math.random() * 999).toString(),
                patlastname: pat.primarycontact.lastname,
                patfirstname: pat.primarycontact.firstname,
                patimage: pat.image,
                patbdate: pat.svdata.bdateat,
                patsv: pat.svdata.sv,
                patsvnr: pat.svdata.svnr,
                fdate: moment().locale('de-at').format('ll')
            };

              if (angular.isDefined(pat.dicompatid)) {
                newrecord.dicompatid = pat.dicompatid;
              }

              if (angular.isDefined(pat.gdtpatid)) {
                newrecord.gdtpatid = pat.gdtpatid;
              }

              Consult.$create(newrecord).$then(function (cons) {
                vm.created = true;
                vm.oncreate({consult: cons});
              }, function (err) {
                vm.created = false;
                $log.error('Creation of new consult failed: ', err);
                Rlog.error('vcutils.consult', 'consultnew', 'Creation of new consult failed: ', {
                  patientid: vm.patientid
                });
              });
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new consult failed, patient invalid: ', err);
              Rlog.error('vcutils.consult', 'consultnew', 'Creation of new consult failed, patientinvalid: ', {
                patientid: vm.patientid
              });
            });
          } // savenewconsult


        }// controller
      ] // controller
    }); // component

// klammerfriedhof
}());
